import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "md:container m-0 md:mx-auto md:mt-8 mb-64 w-full"
}
const _hoisted_2 = { class: "mb-8 w-full h-full bg-white rounded shadow" }
const _hoisted_3 = ["poster"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex justify-between p-4 text-white bg-black" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "hidden md:block space-x-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Suggest Changes ")
const _hoisted_10 = { class: "p-4" }
const _hoisted_11 = { class: "py-4 text-3xl" }
const _hoisted_12 = { class: "flex flex-wrap mb-6" }
const _hoisted_13 = { class: "mb-8 w-5/6" }
const _hoisted_14 = { class: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-2 md:gap-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_image = _resolveComponent("b-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_performer_card = _resolveComponent("performer-card")!
  const _component_va_overlay = _resolveComponent("va-overlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_va_overlay, {
      loading: _ctx.$apollo.loading
    }, {
      default: _withCtx(() => [
        (_ctx.scene)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  (_ctx.scene.trailer)
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 0,
                        controls: "controls",
                        poster: _ctx.sceneEntity.background,
                        muted: "muted",
                        class: "object-cover w-full"
                      }, [
                        _createElementVNode("source", {
                          src: _ctx.scene.trailer,
                          type: "video/mp4"
                        }, null, 8, _hoisted_4)
                      ], 8, _hoisted_3))
                    : (_openBlock(), _createBlock(_component_b_image, {
                        key: 1,
                        src: _ctx.sceneEntity.background,
                        preset: "backgroundLarge",
                        class: "w-full bg-cover",
                        contain: "",
                        alt: _ctx.scene.title
                      }, null, 8, ["src", "alt"]))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.scene.site)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: `/sites/${_ctx.scene.site.short_name}`,
                          class: "flex items-center mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.scene.site.favicon)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.scene.site.favicon.url,
                                  class: "mr-2 flex-shrink h-1 w-1",
                                  alt: _ctx.scene.site.name
                                }, null, 8, _hoisted_7))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.scene.site.name), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" - " + _toDisplayString(_ctx.sceneEntity.dateFormatted), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: `${_ctx.scene.id}/suggest-changes`,
                      class: "py-1 px-2 text-sm text-white bg-yellow-500 hover:bg-yellow-600 rounded transition duration-300 ease select-none"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.scene.title), 1),
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scene.tags.collection, (tag) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: `tag-${tag.id}`,
                        class: "py-1 px-2 mr-1 mb-1 text-sm text-gray-900 bg-gray-300 rounded"
                      }, _toDisplayString(tag.name), 1))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.scene.description), 1),
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sceneEntity.performers, (performer) => {
                      return (_openBlock(), _createBlock(_component_performer_card, {
                        key: `performer-${performer.id}`,
                        performer: performer
                      }, null, 8, ["performer"]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}